export default {
  methods: {
    async $notify(msg) {
      this.global.notify = msg;
    }
  }
}
